<!-- 在发放方式-倒计时,展示倒计时输入框  -->
<template>
  <div class="plv-ia-rpr-send__content">
    <div class="plv-ia-rpr-cell">
      <div class="plv-ia-rpr-cell__left">
        <span> {{ t('plvIA.redpacketRain.countDown') }}</span>
      </div>
      <div class="plv-ia-rpr-cell__right">
        <input
          v-model="delayTime"
          class="c-rp-delayTime-input"
          type="number"
          maxlength="3"
        />
        <span
          class="c-rp-delayTime-msg"
        >{{ t('plvIA.redpacketRain.beforeGet') }}
          <span>{{ t('plvIA.redpacketRain.seeExample') }}
            <div class="c-rp-delayTime-demo-sanjiao"></div>
            <div
              class="c-rp-delayTime-demo"
              :class="{ 'c-rp-delayTime-demo__equal': curType === 1 , 'c-rp-delayTime-demo__equal--password': curType === 1 && tabVal === tabType.password}"
            >
              <div class="c-rp-delayTime-demo-title">
                {{ t('plvIA.redpacketRain.watchPageExample') }}
              </div>
              <div>
                <img
                  v-show="tabVal === tabType.rain"
                  class="c-rp-delayTime-demo-img"
                  src="../images/delayTime-rain.png"
                  alt=""
                />
                <img
                  v-show="tabVal === tabType.password"
                  class="c-rp-delayTime-demo-img"
                  src="../images/delayTime-password.png"
                  alt=""
                />
                <img
                  v-show="tabVal === tabType.normal"
                  class="c-rp-delayTime-demo-img"
                  src="../images/delayTime-normal.png"
                  alt=""
                />
              </div>
            </div>
          </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Locale from '@/mixins/locale';
import redpacketBaseData from '../mixins/redpacket-base-data';
export default {
  name: 'RpDelayTime',
  mixins: [Locale, redpacketBaseData],
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: [Number, String],
      default: ''
    },
    /** 判断当前红包类型 0 拼手气 1 等分 */
    curType: {
      type: [Number],
      default: 0
    },
    tabVal: {
      type: String,
      default: 'OFFICIAL_NORMAL'
    }
  },
  data() {
    return {
      delayTime: 3
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        if (newVal === null) return;
        this.delayTime = newVal;
      }
    },
    delayTime: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          let delayTime = newVal;
          delayTime = delayTime.toString().replace(/\D/g, '');
          this.$emit('change', delayTime);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type='number'] {
  -moz-appearance: textfield;
}
.plv-ia-rpr-cell__right {
  font-size: 14px;
  display: flex;
  align-items: center;
  .c-rp-delayTime-input {
    width: 64px;
    padding: 0;
    text-align: center;
  }
  .c-rp-delayTime-msg {
    font-size: 14px;
    margin-left: 15px;
    span {
      display: inline-block;
      color: #2196f3;
      cursor: pointer;
      position: relative;
      .c-rp-delayTime-demo-sanjiao {
        display: none;
        position: absolute;
        top: -2px;
        left: -18px;
        box-sizing: border-box;
        width: 15px;
        height: 25px;
        background-image: url('../images/sanjiao.png');
        background-size: 100% 100%;
        z-index: 1000;
      }
      .c-rp-delayTime-demo {
        display: none;
        color: #000;
        position: absolute;
        left: -275px;
        top: -400px;
        // width: 264px;
        // height: 566px;
        border: 1px solid #cfd8dc;
        text-align: center;
        padding: 12px;
        background-color: white;
        z-index: 999;
        .c-rp-delayTime-demo-title {
          font-size: 16px;
          margin-bottom: 16px;
          color: #333333;
        }
        .c-rp-delayTime-demo-img {
          width: 232px;
          height: 502px;
          vertical-align: bottom;
        }
      }
      .c-rp-delayTime-demo__equal {
        top: -284px;
      }
      .c-rp-delayTime-demo__equal--password {
        top: -330px !important;
      }
    }
    span:hover {
      .c-rp-delayTime-demo {
        display: block;
      }
      .c-rp-delayTime-demo-sanjiao {
        display: block;
      }
      .c-rp-delayTime-demo-sanjiao-bgmark {
        display: block;
      }
    }
  }
}
body[data-lang='en'] {
  .plv-ia-rpr-cell__right {
    position: relative;
  }
  .c-rp-delayTime-msg {
    position: absolute;
    top: 11px;
    left: 64px;
    text-align: center;
  }
}
</style>
